module.exports = __webpack_public_path__ + "img/register-invite.b30d0757.png";